import { IconeConcluido, IconePortaAberta, IconePrancha, IconeColarCervical } from '../icones'

interface Props {
  faseAtual?: string
  comPrancha: boolean
  configuracao: 'sobreRodas' | 'lateral' | 'invertido'
  aoPularParaFase?: (fracao: number) => void
  colarColocado?: boolean
  portasAbertas?: boolean
  pranchaInserida?: boolean
}

/**
 * Guia Rápido Técnico da Operação de Extração veicular.
 *
 * Oferece clareza imediata e intuitiva aos bombeiros e alunos sobre o roteiro
 * sequencial da retirada com prancha ou pá de forno.
 */
export function GuiaRapidoExtracao({
  faseAtual,
  configuracao,
  aoPularParaFase,
  colarColocado = false,
  portasAbertas = false,
  pranchaInserida = false,
}: Props) {
  const paDeForno = configuracao !== 'sobreRodas'

  const etapas = [
    {
      num: '1',
      titulo: paDeForno ? 'Abertura do Porta-Malas' : 'Acesso & Abertura de Portas',
      descricao: paDeForno ? 'Acesso principal pela tampa traseira' : 'Liberação dos vãos para manobra',
      concluida: portasAbertas,
      tempo: 0.08,
      Icone: IconePortaAberta,
    },
    {
      num: '2',
      titulo: 'Imobilização & Preparo',
      descricao: 'Colar cervical, encostos de cabeça e reclinação dos bancos',
      concluida: colarColocado,
      tempo: 0.28,
      Icone: IconeColarCervical,
    },
    {
      num: '3',
      titulo: paDeForno ? 'Pá de Forno pela Traseira' : 'Inserção da Prancha & Rota',
      descricao: paDeForno ? 'Elevação da vítima e entrada sob a pelve' : 'Entrada pelo ângulo de saída e alinhamento',
      concluida: pranchaInserida,
      tempo: 0.65,
      Icone: IconePrancha,
    },
  ]

  return (
    <div className="guia-rapido-extracao">
      <div className="guia-rapido-extracao__topo">
        <span className="guia-rapido-extracao__badge">ROTEIRO OPERACIONAL</span>
        {faseAtual && <span className="guia-rapido-extracao__fase">{faseAtual}</span>}
      </div>

      <div className="guia-rapido-extracao__passos">
        {etapas.map((etapa) => (
          <button
            key={etapa.num}
            type="button"
            className={`guia-rapido-extracao__passo${etapa.concluida ? ' concluido' : ''}`}
            onClick={() => aoPularParaFase?.(etapa.tempo)}
            title={`Pular para: ${etapa.titulo}`}
          >
            <div className="guia-rapido-extracao__passo-icone">
              {etapa.concluida ? <IconeConcluido tamanho={14} /> : <etapa.Icone tamanho={14} />}
            </div>
            <div className="guia-rapido-extracao__passo-info">
              <span className="guia-rapido-extracao__passo-num">PASSO {etapa.num}</span>
              <strong className="guia-rapido-extracao__passo-titulo">{etapa.titulo}</strong>
              <span className="guia-rapido-extracao__passo-desc">{etapa.descricao}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}
